export { default } from "./SearchBar";
export { SearchBar, addSearchBarTranslations } from "./SearchBar";
//# sourceMappingURL=index.js.map